import { useRef } from 'react';
import { useHeaderHeight } from '@hooks/use-header-height';
import type { ReactNode } from 'react';
import type { TLocalize } from '@hooks/use-localize';
import BackToDashboard from '@components/chrome/back-to-dashboard';
import LanguageDropdown from '@components/language-dropdown';
import Welcome from '@components/chrome/welcome';
import FamilyBar from './family-bar';
import Footer from './footer';

interface IProps {
    t: TLocalize;
    hasMultipleLanguages: boolean;
    dashboardLink: string | null;
    centerName: string;
    centerLogoUrl: string | null;
    centerSiteUrl: string | null;
    centerBackground: string | null;
    subDomain: string | null;
    children: ReactNode;
}

const PlChrome = ({
    t,
    hasMultipleLanguages,
    dashboardLink,
    centerName,
    centerLogoUrl,
    centerSiteUrl,
    centerBackground,
    subDomain,
    children,
}: IProps) => {
    const headerRef = useRef<HTMLDivElement>(null);

    useHeaderHeight(headerRef, true);

    const brand = centerLogoUrl ? (
        <img className={`img-responsive pl-header__logo${subDomain ? ` pl-header__logo--${subDomain}` : ''}`} src={centerLogoUrl} alt={centerName} />
    ) : (
        <span className="pl-header__name">{centerName}</span>
    );

    return (
        <div className="intake-form">
            <style>{`body { padding-top: 67px; }`}</style>
            <a className="sr-only" href="#content">
                Skip navigation
            </a>

            <header ref={headerRef}>
                <div className="row">
                    <div className="col-xs-6">
                        {centerSiteUrl ? (
                            <a href={centerSiteUrl} target="_blank" rel="noreferrer">
                                {brand}
                            </a>
                        ) : (
                            brand
                        )}
                    </div>
                    <div
                        className="col-xs-12 col-sm-6"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            flexWrap: 'wrap',
                        }}
                    >

                        <div style={{ marginRight: 10 }}><BackToDashboard link={dashboardLink} t={t} /></div>
                        <Welcome t={t} />
                        <div id="languagediv">
                            {hasMultipleLanguages && <LanguageDropdown />}
                        </div>
                    </div>
                </div>
            </header>

            <div className="pageHeader-pl" style={{ backgroundColor: centerBackground ? centerBackground : '' }}>&nbsp;</div>

            {centerBackground ?
                <div>{children}</div>
                :
                <>{children}</>
            }

            <FamilyBar />

            <Footer />
        </div>
    );
};

export default PlChrome;
